import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Periode } from '@teetsh/app/src/containers/Livrets/types/livret';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import deserializeDateFromServer from '@teetsh/app/src/utils/time/deserializeDateFromServer';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { PeriodeView } from 'containers/CarnetsDeNotes/queries/types/periode';

export const PERIODES_KEY = 'periodes';

export function deserializePeriode(periode: PeriodeView, tz: string): Periode {
  return {
    ...periode,
    from: deserializeDateFromServer(parseISO(periode.from), tz),
    to: deserializeDateFromServer(parseISO(periode.to), tz),
  };
}

function getPeriodes({
  schoolyearId,
  schoolId,
  tz,
}: {
  schoolyearId: string;
  schoolId: string;
  tz: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/periodes`;
  return request(requestURL, {
    method: 'GET',
  }).then(rep => rep.data.map(p => deserializePeriode(p, tz)));
}

export function usePeriodes() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { location } = useUser();
  return useQuery({
    queryKey: [schoolyear.id, school.id, PERIODES_KEY],
    queryFn: () =>
      getPeriodes({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        tz: location,
      }),

    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
}
